import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Row, Col, Popover} from 'antd';
import { QuestionCircleOutlined,DownloadOutlined } from '@ant-design/icons';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import help from '../../config/help.json';
import {CSVLink} from 'react-csv';


import './analytics.css';


var cc_data;
var cc_data1;
var contentlist;

class AdImpressionIdCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
		 }
	}

	async componentDidUpdate(prevProps) {
	}


	render() {
		const {opensearchAdImpressionByIdList,advertisementOrderListAll,opensearchCtaClickByAdIdList } = this.props;

		cc_data = opensearchAdImpressionByIdList || [];
		//cc_data = cc_data.sort((a, b) => b.doc_count - a.doc_count);
		contentlist = advertisementOrderListAll || [];

		cc_data1 = opensearchCtaClickByAdIdList || [];
		let dataset_clicks = [];
		cc_data1.forEach(d => {
			if(d.adLocation && d.adLocation.buckets){
				d.adLocation.buckets.forEach(c => {
					dataset_clicks.push({key: d.key, doc_count: c.doc_count, ad_location: c.key});
				})
			}
		})

		let dataset = [];
		cc_data.forEach(d => {
			if(d.adLocation && d.adLocation.buckets){
				d.adLocation.buckets.forEach(c => {
					const click = dataset_clicks.find((value) => value.key === d.key && value.ad_location === c.key);
					const details = contentlist.find((value) => value.assetId === d.key );
					dataset.push({key: d.key, doc_count: c.doc_count, ad_location: c.key , clicks:click?click.doc_count:0, details :details });
				})
			}
		})
		dataset = dataset.sort((a, b) => b.doc_count - a.doc_count);
		
		// function getPoster(contentid){
		// 	let poster = require('../../../src/static/no_image.jpg');
		// 	contentlist.map(c => {
		// 		if(c.assetId && c.assetId === contentid){
		// 			poster =  c.asset;
		// 		}				
		// 	})
		// 	return poster;
		// };
		// function getContentType(contentid){
		// 	let poster;
		// 	contentlist.map(c => {
		// 		if(c.assetId && c.assetId === contentid){
		// 			poster =  c.asset;
		// 		}				
		// 	})
		// 	if(poster && poster.includes('mp4')){
		// 		return 'video'
		// 	}else{
		// 		return 'image'
		// 	}
		
		// }
		const settings = {
			focusOnSelect: true,
			infinite: true,
			variableWidth: true,
			slidesToScroll: 1,
			//speed: 500,
		  };
		// const option = {
		// 	dataset: {
		// 		source: cc_data
		// 	  },
		// 	grid: { containLabel: true },
		// 	toolbox: {
		// 		showTitle: false,
		// 	  show: true,
		// 	  orient: 'vertical',
		// 	  left: 'right',
		// 	  top: 'center',
		// 	  feature: {
		// 		mark: { show: true },
		// 		dataView: { show: true, readOnly: false, lang:['Data View', 'Close', 'Refresh'],title:'Data View' },
		// 		magicType: { show: true, type: ['line'],title:{line:'Line Chart', bar:'Bar Chart',stack:'Stack Chart',tiled:'Tiled Chart' }},
		// 		restore: { show: true, title:'Refresh' },
				
		// 	  }
		// 	},
		// 	tooltip: {
		// 	  trigger: 'axis',
		// 	  axisPointer: {
		// 		type: 'shadow'
		// 	  }
		// 	},
		// 	xAxis: { type: 'value' },
		// 	yAxis: { type: 'category' },
		// 	series: [
		// 	  {
		// 		type: 'bar'
		// 	  }
		// 	]
		//   };

		return (
      <Card className="analyticCard ant-card">
				<h3 className="title">{`Ad impression by Ad ID, Ad location, asset URL clicks and CTR  `}
					<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='AdImpressionIdCard').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={dataset.map((c,k) => ({items: k+1 , id:c.key,name:c.details?c.details.name:"", location:c.ad_location,views:c.doc_count,clicks:c.clicks,CTR:c.doc_count > 0 ? `${(c.clicks / c.doc_count * 100).toFixed(1)}%` : '0%'}))} target="_blank" filename={"Ad impression by Ad ID and Ad location.csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				<Row>
				 <Col span={24}>
				 	{/* <ReactECharts style={{ height: 320, width: '100%' }} theme={userTheme} option={option} notMerge={true} showLoading={loading} loadingOption={{color:"#74add1"}} /> */}
					 <Slider   {...settings}>
							{
								dataset.map((d, k) =>(
								
									<div key= 'poster' className='poster'>
										{/* <div key='image' className='poster detail'> {getContentType(d.key)=== 'image'? <img src={getPoster(d.key)} className='poster image' ></img> : <video controls  src={getPoster(d.key)} className='poster image'></video>}</div> */}
										<div key='image' className='poster detail'> {d.details?d.details.asset.includes('mp4')? <video controls  src={d.details.asset?d.details.asset:require('../../../src/static/no_image.jpg')} className='poster image'></video> :<img alt="" src={d.details.asset?d.details.asset:require('../../../src/static/no_image.jpg')} className='poster image' ></img> : <img alt="" src={require('../../../src/static/no_image.jpg')} className='poster image' ></img>}</div>
										<div key='title' className='poster detail'><p className="portaitPoster title">#{k+1}  {d.key}</p></div>
										<div key='name' className='poster detail'><p className="portaitPoster view">{d.details?d.details.name:""}</p></div>
										<div key='location' className='poster detail'><p className="portaitPoster view">{d.ad_location}</p></div>	
										<div key='views' className='poster detail'><p className="portaitPoster view">{d.doc_count} views</p></div>
										<div key='clicks' className='poster detail'><p className="portaitPoster view">{d.clicks} clicks</p></div>
										<div key='ctr' className='poster detail'><p className="portaitPoster view">{d.doc_count > 0 ? `${(d.clicks / d.doc_count * 100).toFixed(1)}%` : '0%'} CTR</p></div>
									</div>
									)
									
								)
							}
							
						
						</Slider>
				</Col>
 				</Row>
     </Card>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	selectedOrganization: state.user.selectedOrganization,
	opensearchAdImpressionByIdList: state.advertisement.opensearchAdImpressionByIdList,
	advertisementOrderListAll: state.advertisement.advertisementOrderListAll,
	opensearchCtaClickByAdIdList : state.advertisement.opensearchCtaClickByAdIdList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdImpressionIdCard));
